<template lang="html">
  <section class="experience-section-component">
    <div class="container">
      <div class="box-content">
        <!-- <h2 class="text-center title-2">Nosotros</h2> -->

        <!-- <p class="p-md text-center">
          xx
        </p> -->

        <div class="row row-info">
          <div class="col-lg-5 col-xl-4 col-image">
            <img src="public/images/isotipo-white.svg">
          </div>

          <div class="col-lg-7 ml-xl-4 col-info">
            <p>
              Nos apasiona ser parte de tus momentos más importantes, ofreciéndote asesoría personalizada y productos de alta calidad para que luzcas espectacular en tu celebración.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
}
</script>
